import React, { useEffect, useState } from 'react';
import { useWallet } from '@solana/wallet-adapter-react';
import axios from 'axios';
import TOSModal from '../Modals/TOSModal';
import Sidebar from './Sidebar';
import TopBar from '../TopBar';

const LayoutWrapper = ({ children, user, setUser }) => {
  const { publicKey } = useWallet();
  const [showTOSModal, setShowTOSModal] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  const toggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev);
  };

  useEffect(() => {
    const fetchUser = async () => {
      if (publicKey) {
        console.log('⏳ Connecting wallet...');
        try {
          const walletAddress = publicKey.toBase58();
          const res = await axios.post('http://localhost:5000/api/users/connect', {
            wallet_address: walletAddress,
          });

          console.log('✅ User fetched/created:', res.data);
          setUser(res.data);
          window.localStorage.setItem('userWallet', walletAddress);

          if (!res.data.agreed_tos) {
            console.log('🚨 Showing TOS Modal');
            setShowTOSModal(true);
          } else {
            console.log('🟢 User has already agreed to TOS');
          }
        } catch (err) {
          console.error('❌ Error connecting wallet:', err);
        }
      } else {
        // Wallet disconnected
        console.log('🔌 Wallet disconnected. Clearing user state.');
        setUser(null);
        window.localStorage.removeItem('userWallet');
      }
    };

    fetchUser();
  }, [publicKey, setUser]);

  const handleAgreeTOS = async (email) => {
    try {
      const res = await axios.put('http://localhost:5000/api/users/update', {
        wallet_address: publicKey.toBase58(),
        email: email || null,
        agreed_tos: true,
      });

      console.log('✅ TOS accepted and user updated:', res.data);
      setUser(res.data);
      setShowTOSModal(false);
    } catch (err) {
      console.error('❌ Error updating user with TOS agreement:', err);
    }
  };

  return (
    <>
      {showTOSModal && <TOSModal onAgree={handleAgreeTOS} />}
      <div className="app-layout" style={{ display: 'flex', minHeight: '100vh' }}>
        <Sidebar isOpen={isSidebarOpen} toggle={toggleSidebar} />
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
          <TopBar />
          <main style={{ flex: 1, backgroundColor: '#2a2a2a' }}>{children}</main>
        </div>
      </div>
    </>
  );
};

export default LayoutWrapper;
